import { TypedDocumentNode, gql } from '@apollo/client';
import {
  GetContactsInput,
  GetContactsResponse,
  UpdateSavedContactInput,
  UpdateSavedContactResponse,
} from './schema';

export const GetContactsQuery: TypedDocumentNode<
  GetContactsResponse,
  GetContactsInput
> = gql`
  query GetContacts(
    $userId: String!
    $alias: String!
    $timeOption: TimeOption!
    $timestamp: String!
  ) {
    getContacts(
      userId: $userId
      alias: $alias
      timeOption: $timeOption
      timestamp: $timestamp
    ) {
      pastContacts {
        CALL_DURATION_SECONDS
        CHANNEL_NAME
        COMM_ID
        OWNERSHIP_TYPE
        SAVED
        SIC_NODE_1_NAME
        TIME
      }
      savedContacts {
        CALL_DURATION_SECONDS
        CHANNEL_NAME
        COMM_ID
        OWNERSHIP_TYPE
        SAVED
        SIC_NODE_1_NAME
        TIME
      }
    }
  }
`;

export const UpdateSavedContactsMutation: TypedDocumentNode<
  UpdateSavedContactResponse,
  UpdateSavedContactInput
> = gql`
  mutation UpdateSavedContacts(
    $action: SavedContactAction!
    $channel: String
    $contactId: String!
    $dateAndTime: String!
    $duration: String
    $ownershipType: String
    $sic: String
    $userId: String!
  ) {
    updateSavedContacts(
      action: $action
      channel: $channel
      contactId: $contactId
      dateAndTime: $dateAndTime
      duration: $duration
      ownershipType: $ownershipType
      sic: $sic
      userId: $userId
    ) {
      status
    }
  }
`;
